export interface CityEntry {
  name: string;
  coordinates: [number, number]; // [lat, lng]
}

/**
 * Italian cities dataset for the MapPage city search.
 *
 * Coverage: All Lombardia province capitals and major comuni,
 * Cremasco area towns, and capitals/major cities of neighboring
 * regions (Piemonte, Veneto, Emilia-Romagna, Trentino-Alto Adige,
 * Liguria, Valle d'Aosta, Friuli Venezia Giulia).
 *
 * Sorted alphabetically by name.
 */
export const italianCities: CityEntry[] = [
  // A
  { name: 'Abbiategrasso', coordinates: [45.3981, 8.9169] },
  { name: 'Adro', coordinates: [45.6206, 9.9622] },
  { name: 'Alessandria', coordinates: [44.9122, 8.6154] },
  { name: 'Aosta', coordinates: [45.7372, 7.3209] },
  { name: 'Asti', coordinates: [44.9004, 8.2065] },

  // B
  { name: 'Bergamo', coordinates: [45.6983, 9.6773] },
  { name: 'Biella', coordinates: [45.5628, 8.0531] },
  { name: 'Bologna', coordinates: [44.4949, 11.3426] },
  { name: 'Bolzano', coordinates: [46.4983, 11.3548] },
  { name: 'Brescia', coordinates: [45.5416, 10.2118] },
  { name: 'Broni', coordinates: [45.0661, 9.2614] },
  { name: 'Busto Arsizio', coordinates: [45.6119, 8.849] },

  // C
  { name: 'Calcinato', coordinates: [45.4569, 10.4063] },
  { name: 'Cantù', coordinates: [45.7399, 9.1303] },
  { name: 'Caravaggio', coordinates: [45.4969, 9.6425] },
  { name: 'Casale Monferrato', coordinates: [45.1333, 8.45] },
  { name: 'Casaletto Vaprio', coordinates: [45.3831, 9.62] },
  { name: 'Casalmaggiore', coordinates: [44.9867, 10.4194] },
  { name: 'Casalpusterlengo', coordinates: [45.1781, 9.6517] },
  { name: "Cassano d'Adda", coordinates: [45.5261, 9.5175] },
  { name: 'Castelleone', coordinates: [45.2942, 9.7636] },
  { name: 'Castiglione delle Stiviere', coordinates: [45.3906, 10.49] },
  { name: 'Chiari', coordinates: [45.5372, 9.9303] },
  { name: 'Chiavenna', coordinates: [46.3203, 9.3986] },
  { name: 'Cinisello Balsamo', coordinates: [45.5581, 9.2144] },
  { name: 'Codogno', coordinates: [45.1614, 9.7017] },
  { name: 'Cologno Monzese', coordinates: [45.53, 9.2789] },
  { name: 'Como', coordinates: [45.8081, 9.0852] },
  { name: 'Cortemaggiore', coordinates: [44.9928, 9.9319] },
  { name: 'Crema', coordinates: [45.3636, 9.6869] },
  { name: 'Cremona', coordinates: [45.1333, 10.0167] },
  { name: 'Cuneo', coordinates: [44.3845, 7.5427] },

  // D
  { name: 'Darfo Boario Terme', coordinates: [45.8836, 10.1819] },
  { name: 'Desenzano del Garda', coordinates: [45.4706, 10.5367] },
  { name: 'Desio', coordinates: [45.6222, 9.2097] },

  // E
  { name: 'Edolo', coordinates: [46.1783, 10.3292] },
  { name: 'Erba', coordinates: [45.8139, 9.2258] },

  // F
  { name: 'Ferrara', coordinates: [44.8381, 11.6198] },
  { name: 'Fidenza', coordinates: [44.8661, 10.0611] },

  // G
  { name: 'Gallarate', coordinates: [45.6606, 8.7914] },
  { name: 'Gorgonzola', coordinates: [45.5314, 9.4042] },
  { name: 'Genova', coordinates: [44.4056, 8.9463] },

  // I
  { name: 'Iseo', coordinates: [45.6594, 10.0503] },
  { name: 'Ivrea', coordinates: [45.4667, 7.8756] },

  // L
  { name: 'La Spezia', coordinates: [44.1071, 9.8282] },
  { name: 'Lecco', coordinates: [45.8566, 9.3977] },
  { name: 'Legnano', coordinates: [45.5964, 8.9161] },
  { name: 'Leno', coordinates: [45.3686, 10.2186] },
  { name: 'Lissone', coordinates: [45.6106, 9.2444] },
  { name: 'Lodi', coordinates: [45.3138, 9.5037] },
  { name: 'Lonato del Garda', coordinates: [45.4614, 10.4806] },
  { name: 'Lovere', coordinates: [45.8142, 10.0681] },
  { name: 'Lumezzane', coordinates: [45.6506, 10.2656] },

  // M
  { name: 'Magenta', coordinates: [45.4631, 8.8831] },
  { name: 'Manerbio', coordinates: [45.3542, 10.1397] },
  { name: 'Mantova', coordinates: [45.1564, 10.7914] },
  { name: 'Melzo', coordinates: [45.4972, 9.42] },
  { name: 'Merano', coordinates: [46.6713, 11.1594] },
  { name: 'Milano', coordinates: [45.4642, 9.19] },
  { name: 'Modena', coordinates: [44.6471, 10.9252] },
  { name: 'Moncalieri', coordinates: [45.0022, 7.6828] },
  { name: 'Monza', coordinates: [45.5845, 9.2745] },
  { name: 'Mortara', coordinates: [45.2506, 8.7375] },

  // N
  { name: 'Novara', coordinates: [45.4494, 8.621] },

  // O
  { name: 'Offanengo', coordinates: [45.3764, 9.7406] },
  { name: 'Orzinuovi', coordinates: [45.3983, 9.9247] },

  // P
  { name: 'Padova', coordinates: [45.4064, 11.8768] },
  { name: "Palazzolo sull'Oglio", coordinates: [45.5997, 9.8839] },
  { name: 'Pandino', coordinates: [45.4053, 9.5519] },
  { name: 'Parma', coordinates: [44.8015, 10.3279] },
  { name: 'Pavia', coordinates: [45.1847, 9.1582] },
  { name: 'Piacenza', coordinates: [45.0526, 9.693] },
  { name: 'Pioltello', coordinates: [45.4886, 9.3256] },
  { name: 'Pizzighettone', coordinates: [45.1867, 9.785] },
  { name: 'Ponte di Legno', coordinates: [46.2578, 10.5097] },
  { name: 'Pordenone', coordinates: [45.9564, 12.6605] },

  // R
  { name: 'Reggio Emilia', coordinates: [44.6983, 10.6312] },
  { name: 'Rho', coordinates: [45.5306, 9.0397] },
  { name: 'Rimini', coordinates: [44.0594, 12.5681] },
  { name: "Rivolta d'Adda", coordinates: [45.4694, 9.5125] },
  { name: 'Romano di Lombardia', coordinates: [45.5189, 9.7547] },
  { name: 'Rovato', coordinates: [45.5631, 10.0003] },
  { name: 'Rovereto', coordinates: [45.8867, 11.0369] },

  // S
  { name: 'Salò', coordinates: [45.6064, 10.5219] },
  { name: 'San Donato Milanese', coordinates: [45.4136, 9.2672] },
  { name: 'Saronno', coordinates: [45.6261, 9.0325] },
  { name: 'Savona', coordinates: [44.3091, 8.4772] },
  { name: 'Seregno', coordinates: [45.6531, 9.2008] },
  { name: 'Sesto San Giovanni', coordinates: [45.5328, 9.2381] },
  { name: 'Soncino', coordinates: [45.3992, 9.8756] },
  { name: 'Sondrio', coordinates: [46.1699, 9.8713] },
  { name: 'Soresina', coordinates: [45.2894, 9.8564] },

  // T
  { name: 'Tirano', coordinates: [46.2153, 10.1694] },
  { name: 'Torino', coordinates: [45.0703, 7.6869] },
  { name: 'Trento', coordinates: [46.0748, 11.1217] },
  { name: 'Treviglio', coordinates: [45.5211, 9.5917] },
  { name: 'Treviso', coordinates: [45.6669, 12.243] },
  { name: 'Trieste', coordinates: [45.6495, 13.7768] },

  // U
  { name: 'Udine', coordinates: [46.0711, 13.2346] },

  // V
  { name: 'Varese', coordinates: [45.8206, 8.8257] },
  { name: 'Venezia', coordinates: [45.4408, 12.3155] },
  { name: 'Vercelli', coordinates: [45.3225, 8.4186] },
  { name: 'Verona', coordinates: [45.4384, 10.9917] },
  { name: 'Viadana', coordinates: [44.9267, 10.5178] },
  { name: 'Vicenza', coordinates: [45.5455, 11.5354] },
  { name: 'Vigevano', coordinates: [45.3167, 8.8583] },
  { name: 'Villasanta', coordinates: [45.6044, 9.305] },
  { name: 'Vimercate', coordinates: [45.6142, 9.37] },
  { name: 'Voghera', coordinates: [44.9931, 9.0092] },
];
